export const defaultSystemMessageBoxStyles = {
  maxWidth: "90%"
};